import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-details-step',
  templateUrl: './contact-details-step.component.html',
  styleUrls: ['./contact-details-step.component.scss']
})
export class ContactDetailsStepComponent {

  @Input() form!: FormGroup
  @Input() formControlName!: string;
  @Input() placeholder: string = this.TranslateService.instant('write_here');

  constructor(private TranslateService: TranslateService) { }
}
